import { observer } from 'mobx-react-lite';
import {
    FrBoloPageTab,
    frBoloPageTabConfig,
} from '~/fr-bolos-page/configuration/fr-bolo-tab-configuration';
import { useEnabledFeatures } from '~/common/hooks/enabled-features/use-enabled-features';
import { FrTab } from '~/fr-event-common-components/fr-tab';
import { FrTabs } from '~/fr-event-common-components/fr-tabs';

interface FrBoloPageTabsProps {
    activeTab?: FrBoloPageTab;
    onChangeTab: (tab: FrBoloPageTab) => void;
}

export const FrBoloPageTabs = observer(({ activeTab, onChangeTab }: FrBoloPageTabsProps) => {
    const enabledFeatures = useEnabledFeatures();
    const tabs = Object.values(frBoloPageTabConfig).filter(
        (t) => !t.checkEnabled || t.checkEnabled(enabledFeatures)
    );

    return (
        <FrTabs activeTab={activeTab} dataTestId="bolo-tabs">
            {tabs.map((tabConfig) => (
                <FrTab
                    key={tabConfig.type}
                    type={tabConfig.type}
                    icon={tabConfig.icon}
                    title={tabConfig.name}
                    totalTabCount={tabs.length}
                    onClick={() => {
                        onChangeTab(tabConfig.type);
                    }}
                />
            ))}
        </FrTabs>
    );
});
